// StreamMessageRenderer handles permanent elements before dispatching this event.
// Restoring the marker here lets the native morph retain the original live node
// without the stream renderer first cloning its iframe, canvas or media state.
export function restoreStreamPermanence(event) {
  const content = event.target.templateElement?.content;
  for (const element of content?.querySelectorAll('[data-stream-permanent]') || []) {
    element.setAttribute('data-turbo-permanent', '');
    element.removeAttribute('data-stream-permanent');
  }
}
